module.exports = __webpack_public_path__ + "img/ZazaOne.33896389.png";